module.exports = require('./helpers/bundle-url').getBundleURL('9fDO5') + "logo.c51670a8.svg";